/* eslint-disable react/no-array-index-key */
import React, { useContext } from "react";
import {
  Accordion,
  AccordionContext,
  Card,
  useAccordionButton,
} from "react-bootstrap";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";

import { AccordionContainer, Container } from "./styles";

const ContextAwareToggle = ({
  children,
  eventKey,
  callback,
  setActiveKey,
}: any): JSX.Element => {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, () => {
    if (callback) {
      callback(eventKey);
    }
    setActiveKey(eventKey);
  });

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    // @ts-ignore
    <Card.Header onClick={() => decoratedOnClick()}>
      {children}
      {isCurrentEventKey ? (
        <AiOutlineMinus size={14} />
      ) : (
        <AiOutlinePlus size={14} />
      )}
    </Card.Header>
  );
};

const AccordionItens = ({
  items,
  activeKey,
  setActiveKey,
}: any): JSX.Element => {
  return (
    <Container>
      <AccordionContainer>
        <Accordion activeKey={activeKey}>
          {items.map((item, index) => (
            <Card key={index + 1}>
              <ContextAwareToggle
                setActiveKey={setActiveKey}
                eventKey={index + 1}
                callback={false}
              >
                <span>{item.title}</span>
              </ContextAwareToggle>
              <Accordion.Collapse eventKey={index + 1}>
                <Card.Body>{item.description}</Card.Body>
              </Accordion.Collapse>
            </Card>
          ))}
        </Accordion>
      </AccordionContainer>
    </Container>
  );
};

export default AccordionItens;
